module.exports = __webpack_public_path__ + "static/media/image-icon-white.a6708566.svg";